module.exports = __webpack_public_path__ + "img/img_title1@2x.9f9f87c6.png";